import React, { Component } from 'react'

export default class ItemButton extends Component {
  render() {
    return (
      <div className="group w-48 p-8 m-2 border-2 rounded-lg hover:border-blue hover:bg-blue-dark hover:text-white border-grey-dark">
        <a
          className="flex flex-col items-center content-center group-hover:text-white"
          onClick={this.props.event}>
          {this.props.children}
        </a>
      </div>
    )
  }
}
